import { render, staticRenderFns } from "./PortfolioSettingsModal.vue?vue&type=template&id=0bccea20"
import script from "./PortfolioSettingsModal.vue?vue&type=script&lang=js"
export * from "./PortfolioSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./PortfolioSettingsModal.vue?vue&type=style&index=0&id=0bccea20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default,WButton: require('/skade-pwa/components/ui/atom/WButton/WButton.vue').default})
